import { render } from "./EditableInput.vue?vue&type=template&id=56925d0b"
import script from "./EditableInput.vue?vue&type=script&lang=js"
export * from "./EditableInput.vue?vue&type=script&lang=js"

import "./EditableInput.vue?vue&type=style&index=0&id=56925d0b&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__